import routerOptions0 from "/home/runner/work/leilakrejci/leilakrejci/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/home/runner/work/leilakrejci/leilakrejci/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}